export const SET_BRAND_INFO = 'SET_BRAND_INFO';
export const SET_BRAND_IMAGES = 'SET_BRAND_IMAGES';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_FLOW = 'SET_FLOW';
export const SET_BILLING_PROVIDER = 'SET_BILLING_PROVIDER';
